import type * as React from 'react'

import Feedback from 'airship/patterns/feedback'

const ContactSupportAccessDeniedError: React.FC = () => {
  return (
    <>
      <Feedback displayClasses="u-space-bottom-1" type="warning">
        <p className="u-space-bottom-1 u-text-bold">Request not submitted</p>
        <p className="u-space-bottom-05">
          Submitting a support request requires a paid plan. You can:{' '}
        </p>
        <ul className="list u-space-bottom-1">
          <li>
            Review knowledge base articles and post your issue in our public
            forums at{' '}
            <a
              href="https://support.airship.com"
              target="_blank"
              rel="noopener noreferrer"
              className="u-blue u-text-underline"
            >
              support.airship.com
            </a>
          </li>
          <li>
            <a
              href="https://www.airship.com/contact-us/"
              target="_blank"
              rel="noopener noreferrer"
              className="u-blue u-text-underline"
            >
              Contact Airship Sales
            </a>{' '}
            to verify your support level or upgrade to paid plan
          </li>
        </ul>
        <p>
          See our{' '}
          <a
            href="https://www.airship.com/legal/support-services/"
            target="_blank"
            rel="noopener noreferrer"
            className="u-blue u-text-underline"
          >
            Support Services page
          </a>{' '}
          for hours, response times, priorities, and coverage information.
        </p>
      </Feedback>
    </>
  )
}

export default ContactSupportAccessDeniedError
